import { FormType } from "@bitwarden/web-vault/app/gloss/estimates/estimates-add-edit/estimate/form/form-estimate";

export abstract class FormBuilder {
  form: Record<string, any> = {};
  abstract create(form: FormType): FormType;
}
